import React, { useState } from "react";
import GoogleSignInButton from "../Forms/GoogleSignIn/GoogleSignIn";
import faymLogo from "../../assets/icons/mobileIcons/faymLogo.png";
import MobileForm from "../Forms/MobileForm/MobileForm";
import "./index.scss";

const index = () => {
    const [loading, setLoading] = useState(false);

    return (
        <div className="parentContainer">
            <div className="signInContainer">
                <div className="header">
                    <img className="faymLogo" alt="faym-logo" src={faymLogo} />
                    <h1> Welcome Back </h1>
                    <p>Let's get Faymiliar. Transform your Link In Bio in few clicks!</p>
                </div>
                <MobileForm loading={loading} setLoading={setLoading} type="signUp" />

                <div className="dividers">
                    <div className="line"></div>
                    <span>OR</span>
                    <div className="line"></div>
                </div>
                <div className="othersLoginContainer">
                    <GoogleSignInButton type="signUp" loading={loading} setLoading={setLoading} />
                </div>
            </div>
        </div>
    );
};

export default index;
